import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(theme => ({
  bottomSubtitle: {
    fontSize: "0.75rem",
    lineHeight: "0.875rem"
  },
  list: {
    listStyle: "none",
    padding: theme.spacing(2, 1.5),
    borderTop: "1px solid #DDDDDD",
    borderBottom: "1px solid #DDDDDD",
    display: "flex",
    justifyContent: "flex-end",
    margin: theme.spacing(3, -3, 0),
    "& li": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      margin: theme.spacing(0, 1.5)
    },
    "& li.multiplier": {
      margin: theme.spacing(0)
    },
    "& li:first-child": {
      marginRight: "auto"
    }
  },
  listHead: {
    fontWeight: 500,
    fontSize: ".75rem",
    lineHeight: ".875rem",
    color: theme.palette.text.secondary,
    margin: theme.spacing(0, 0, 1.5)
  },
  listCell: {
    fontSize: ".875rem",
    lineHeight: "1rem",
    margin: 0
  },

  total: {
    fontWeight: 500,
    fontSize: ".875rem",
    lineHeight: "1rem",
    backgroundColor: "#f9f9f9",
    color: "#000",
    padding: theme.spacing(1.5, 3),
    margin: theme.spacing(1, -3, 0),
    display: "flex",
    justifyContent: "space-between"
  }
}));

export default function Prorata({
  isEditing,
  currency,
  vehiclesCount,
  chosenPlan,
  paymentMethod
}) {
  const classes = useStyles();

  // Calcuclate prorata
  const date = new Date(); // 2009-11-10
  const currentDate = date.getDate() - 1;
  const daysInMonth = new Date(
    date.getFullYear(),
    date.getMonth() + 1,
    0
  ).getDate();
  const year = new Date(date.getFullYear(), date.getMonth() + 1).getFullYear();
  const month = new Date(
    date.getFullYear(),
    date.getMonth() + 1
  ).toLocaleString("en-US", { month: "long" });

  return (
    <Box pt={4} px={3} display="flex" justifyContent="space-between">
      <Box>
        {paymentMethod === "card" ? (
          isEditing ? (
            <Typography className={classes.bottomSubtitle}>
              By submitting your payment information, you authorize us to charge
              your card a recurring monthly fee in accordance with the plan you
              have chosen. You may be asked for additional authentication on the
              next page.
            </Typography>
          ) : (
            <Typography className={classes.bottomSubtitle}>
              An upgrade to your plan after the 1st of the month is prorated.
              You will only be charged for {daysInMonth - currentDate} days of
              usage for the current month. On {month} 1, {year}, you will be
              charged a recurring monthly fee of {currency.symbol}
              {chosenPlan.price} per vehicle per month.
            </Typography>
          )
        ) : (
          <Typography className={classes.bottomSubtitle}>
            By providing your payment information and confirming this payment, you 
            authorise (A) Storegear B.V. and Stripe, our payment service provider
            and/or PPRO, its local service provider, to send instructions to your
            bank to debit your account and (B) your bank to debit your account in
            accordance with those instructions. As part of your rights, you are
            entitled to a refund from your bank under the terms and conditions of
            your agreement with your bank. A refund must be claimed within 8 weeks
            starting from the date on which your account was debited. Your rights
            are explained in a statement that you can obtain from your bank. You
            agree to receive notifications for future debits up to 2 days before
            they occur.
          </Typography>
        )}
        {!isEditing && (
          <>
            <ul className={classes.list}>
              <li>
                <p className={classes.listHead}>PLAN</p>
                <p className={classes.listCell}>
                  Routetitan {chosenPlan.title}
                </p>
              </li>
              <li style={{ textAlign: "right" }}>
                <p className={classes.listHead}>REMAINING DAYS</p>
                <p className={classes.listCell}>
                  {daysInMonth - currentDate}/{daysInMonth}
                </p>
              </li>
              <li className="multiplier">
                <p className={classes.listHead}></p>
                <p className={classes.listCell}>
                  <i>x</i>
                </p>
              </li>
              <li style={{ textAlign: "center" }}>
                <p className={classes.listHead}>RATE</p>
                <p className={classes.listCell}>
                  {currency.symbol}
                  {chosenPlan.price}
                </p>
              </li>
              <li className="multiplier">
                <p className={classes.listHead}></p>
                <p className={classes.listCell}>
                  <i>x</i>
                </p>
              </li>
              <li style={{ textAlign: "left" }}>
                <p className={classes.listHead}>VEHICLES</p>
                <p className={classes.listCell}>
                  {chosenPlan.name === "individual" ? 1 : vehiclesCount}
                </p>
              </li>
              <li style={{ textAlign: "right" }}>
                <p className={classes.listHead}>AMOUNT</p>
                <p className={classes.listCell}>
                  {currency.symbol}
                  {(
                    ((daysInMonth - currentDate) *
                      chosenPlan.price *
                      (chosenPlan.name === "individual" ? 1 : vehiclesCount)) /
                    daysInMonth
                  ).toFixed(2)}
                </p>
              </li>
            </ul>
            <Box className={classes.total}>
              <span>Today’s total</span>
              <span>
                {currency.symbol}
                {(
                  ((daysInMonth - currentDate) *
                    chosenPlan.price *
                    (chosenPlan.name === "individual" ? 1 : vehiclesCount)) /
                  daysInMonth
                ).toFixed(2)}
              </span>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
}
